import { cacheFirstConfig } from '@/core/helpers/http.helper';
import { LocationQuery } from 'vue-router';
import { http } from '../../helpers/http.helper';
import { ApiResource } from './../../models/api-resource.interface';
import { Country } from './country.interface';

export class CountryService {
   async getCountries(query: LocationQuery) {
      const response = await http.get<ApiResource<Array<Country>>>(`/countries`, { ...cacheFirstConfig, params: { ...query } });
      return response.data?.data;
   }
}
